import { useCallback, useState } from "react";
import { changeStatusReasonRequest } from "../network";
import { isEmpty } from "lodash";

export const useChangeStatusReason = (): [
  any | null,
  boolean,
  Error | null,
  (requestId: string, reason: string, otherReason?: string) => void,
  any,
  React.Dispatch<any>
] => {
  const [validationErrors, setValidationErrors] = useState<any>({});
  const [result, setResult] = useState<any | null>(null);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [error, setError] = useState<Error | null>(null);

  const request = useCallback(
    async (requestId: string, reason: string, otherReason?: string) => {
      setIsLoading(true);
      setError(null);

      try {
        const errors: { [key: string]: boolean } = {};
        if (!reason) {
          errors.reason = true;
        }
        if (reason === "Other" && !otherReason) {
          errors.otherReason = true;
        }

        if (isEmpty(errors)) {
          const complexReason = otherReason
            ? `${reason}: ${otherReason}`
            : reason;
          const response = await changeStatusReasonRequest(
            requestId,
            complexReason
          );
          setResult(response);
        } else {
          setValidationErrors(errors);
        }
      } catch (e) {
        if (e instanceof Error) {
          setError(e);
        } else {
          setError(new Error("Unknown error"));
        }
      }

      setIsLoading(false);
    },
    []
  );

  return [
    result,
    isLoading,
    error,
    request,
    validationErrors,
    setValidationErrors,
  ];
};
